export var DeviceConnectivity;
(function (DeviceConnectivity) {
    DeviceConnectivity["LTE"] = "lte";
    DeviceConnectivity["PCELL02FPATRLTE1"] = "pcell02fpatrlte1";
    DeviceConnectivity["WIFI"] = "wifi";
    DeviceConnectivity["IOTDISCOVERYKIT"] = "iotdiscoverykit";
    DeviceConnectivity["LORA_TTN"] = "Lora_ttn";
    DeviceConnectivity["LORA_LORIOT"] = "Lora_loriot";
    DeviceConnectivity["LORA_MACHINEQ"] = "Lora_machineq";
    DeviceConnectivity["LORA_ACTILITY"] = "Lora_actility";
    DeviceConnectivity["SIGFOX"] = "Sigfox";
    DeviceConnectivity["NUCLEOFPATRSIGFOX1"] = "nucleofpatrsigfox1";
    DeviceConnectivity["NFC"] = "nfc";
    DeviceConnectivity["SMARTAG_LEGACY"] = "smartag";
    DeviceConnectivity["SMARTAG1"] = "smartag1:mcu:fp-sns-smartag1:1";
    DeviceConnectivity["SMARTAG2"] = "smartag2:mcu:fp-sns-smartag2:1";
    DeviceConnectivity["BLE_LEGACY"] = "ble";
    DeviceConnectivity["BLE"] = "sensortile-box:mcu:fp-atr-ble1:1";
    DeviceConnectivity["SENSORTILE"] = "sensortile";
    DeviceConnectivity["SENSORTILE_BOX_PRO"] = "sensortile-box-pro:mcu:fp-atr-ble1:1";
    DeviceConnectivity["HTTP"] = "http";
    DeviceConnectivity["POLARIS"] = "polaris";
    DeviceConnectivity["ASTRA"] = "steval-astra1b:mcu:fp-atr-astra1:1";
    DeviceConnectivity["STEVALHARVEST1"] = "steval-harvest1:mcu:demo:1";
    DeviceConnectivity["NBIOT"] = "nbiot:mcu:demo:1";
    DeviceConnectivity["UNKNOWN"] = "unknown";
})(DeviceConnectivity || (DeviceConnectivity = {}));
export function deserializeDeviceConnectivity(rawValue) {
    let connectivity;
    switch (rawValue) {
        case DeviceConnectivity.BLE_LEGACY.toString():
            connectivity = DeviceConnectivity.BLE_LEGACY;
            break;
        case DeviceConnectivity.BLE.toString():
            connectivity = DeviceConnectivity.BLE;
            break;
        case DeviceConnectivity.SENSORTILE.toString():
            connectivity = DeviceConnectivity.SENSORTILE;
            break;
        case DeviceConnectivity.SENSORTILE_BOX_PRO.toString():
            connectivity = DeviceConnectivity.SENSORTILE_BOX_PRO;
            break;
        case DeviceConnectivity.NFC.toString():
            connectivity = DeviceConnectivity.NFC;
            break;
        case DeviceConnectivity.SMARTAG_LEGACY.toString():
            connectivity = DeviceConnectivity.SMARTAG_LEGACY;
            break;
        case DeviceConnectivity.SMARTAG1.toString():
            connectivity = DeviceConnectivity.SMARTAG1;
            break;
        case DeviceConnectivity.SMARTAG2.toString():
            connectivity = DeviceConnectivity.SMARTAG2;
            break;
        case DeviceConnectivity.WIFI.toString():
            connectivity = DeviceConnectivity.WIFI;
            break;
        case DeviceConnectivity.IOTDISCOVERYKIT.toString():
            connectivity = DeviceConnectivity.IOTDISCOVERYKIT;
            break;
        case DeviceConnectivity.LTE.toString():
            connectivity = DeviceConnectivity.LTE;
            break;
        case DeviceConnectivity.PCELL02FPATRLTE1.toString():
            connectivity = DeviceConnectivity.PCELL02FPATRLTE1;
            break;
        case DeviceConnectivity.LORA_TTN.toString():
            connectivity = DeviceConnectivity.LORA_TTN;
            break;
        case DeviceConnectivity.LORA_LORIOT.toString():
            connectivity = DeviceConnectivity.LORA_LORIOT;
            break;
        case DeviceConnectivity.LORA_MACHINEQ.toString():
            connectivity = DeviceConnectivity.LORA_MACHINEQ;
            break;
        case DeviceConnectivity.LORA_ACTILITY.toString():
            connectivity = DeviceConnectivity.LORA_ACTILITY;
            break;
        case DeviceConnectivity.SIGFOX.toString():
            connectivity = DeviceConnectivity.SIGFOX;
            break;
        case DeviceConnectivity.NUCLEOFPATRSIGFOX1.toString():
            connectivity = DeviceConnectivity.PCELL02FPATRLTE1;
            break;
        case DeviceConnectivity.HTTP.toString():
            connectivity = DeviceConnectivity.HTTP;
            break;
        case DeviceConnectivity.POLARIS.toString():
            connectivity = DeviceConnectivity.POLARIS;
            break;
        case DeviceConnectivity.ASTRA.toString():
            connectivity = DeviceConnectivity.ASTRA;
            break;
        case DeviceConnectivity.STEVALHARVEST1.toString():
            connectivity = DeviceConnectivity.STEVALHARVEST1;
            break;
        case DeviceConnectivity.NBIOT.toString():
            connectivity = DeviceConnectivity.NBIOT;
            break;
        default:
            connectivity = DeviceConnectivity.UNKNOWN;
    }
    return connectivity;
}
//# sourceMappingURL=types.js.map